

























import Vue from 'vue';
import { mapGetters } from 'vuex';
import ContentEditor from '@/dex-shared/components/new_content/ContentEditor.vue';
import Loading from '@/dex-shared/components/Loading.vue';
import pxButton from '@/dex-shared/components/px-button.vue';

export default Vue.extend({
  components: {
    ContentEditor,
    Loading,
    pxButton,
  },

  data() {
    return {
      creating: true,
      pushingSolution: false,
      loaded: true,
    };
  },

  computed: {
    ...mapGetters({
      solutionById: 'solutionById',
    }),
    solution() {
      return this.solutionById(+this.$route.params.solutionId);
    },
  },

  async mounted() {
    this.loaded = false;
    this.creating = this.$route.name === 'solution_create';
    if (this.creating) {
      let questionId = +this.$route.params.questionId;
      let solutionId = await this.$store.dispatch(
        'CREATE_SOLUTION',
        questionId,
      );
      this.$router.push(`/editar_solucao/${solutionId}`);
    } else {
      let solutionId = +this.$route.params.solutionId;
      await this.$store.dispatch('PULL_SOLUTION_BY_ID', solutionId);
      //TODO no solution found
    }
    this.loaded = true;
  },

  methods: {
    pushSolution: async function() {
      //TODO remove null contents
      let questionId = this.solution.questionId;
      if (this.pushingSolution === false && questionId) {
        this.pushingSolution = true;
        await this.$store.dispatch('PUSH_SOLUTION_BY_ID', this.solution.id);
        //TODO error inputing solution
        if (this.solution.id) {
          this.$router.push(`/questao/${questionId}`);
        }
        this.pushingSolution = false;
      }
    },
  },
});
